var parseIsSsrByDefault = () => !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
export var Global = {
  isSsr: parseIsSsrByDefault()
};